<template lang="pug">
  div.print-absolute.map-container.geo.map-objects
    div.no-print.toolbar
      div.line
        h1.title {{$translate('Карта')}}
        //button Выделить и распечатать
        e-suggestion(
          placeholder=" "
          :suggestionEndpoint="suggestionEndpoint"
          :transformSuggestions="transformSuggestions"
          @selectItem="selectItemOnMapSearch"
          name="q"
          :model="suggestionMapSearch"
          :useInnerSearch="false"
          :addInfo="true"
          :addInfoField="'address'"
          :addBorder="true"
        ).search
    map-mapping-legend(
      :mappingCurrentLegend="mappingCurrentLegend"
      :legendItems="legendItems"
    )
    map-layer-legend(
      :items="layerLegendItems"
      :layerGroups="layerGroups"
    )

    div.new-map
      div(ref="map" v-once).bigmap#map

      transition(name="fade")
        div.no-print.legend.legend--objects.cuscroll(:class="showMapLegend ? 'open' : 'close'")
          div(v-if="layersLoading").hover-on-loading
          e-perfect-scrollbar
            div.head(@click="showMapLegend = !showMapLegend")
              h2.title {{$translate('Слои')}}
              //span.toolbar-filter__close
              span.legend__close(v-if="showMapLegend")
              span.legend__open(v-else)

            map-mapping-selector(
              :mappingConfObject="mappingConfObject"
              :selectedMappingObject="selectedMappingObject"
              @change="setSelectedMappingObject"
              @rosreestrChangeView="onRosreestrChangeView"
              @showEquidistant="onShowEquidistant"
              @setEquidistant="updateEquidistantCircle"
              @showEquidistantGeo="setShowEquidistantGeo"
              @equidistantGeo="setEquidistantGeo"
            )

            div.type-group.load
              div.type
                label.checked
                  span.marker {{$translate('Статус')}}
                label.new-check
                  input.new-checkbox(type="checkbox")
                  span
              div.group
                el-tooltip(transition="none" effect="light" placement="left" :content="layers.length === 0 ? 'Выберите объекты' : 'Показать активные объекты'")
                  div.type.status-active
                    label.checked
                      input.checkbox(:disabled="layers.length === 0" type="checkbox" @change="showStatus" v-model="showedStatus" :value="1")
                      span
                      span.marker {{$translate('Действующий')}}
                el-tooltip(transition="none" effect="light" placement="left" :content="layers.length === 0 ? 'Выберите объекты' : 'Показать планируемые объекты'")
                  div.type.status-planned
                    label.checked
                      input.checkbox(:disabled="layers.length === 0" type="checkbox" @change="showStatus" v-model="showedStatus" :value="3")
                      span
                      span.marker {{$translate('Планируемый')}}

            div(v-for="(item, name) in layersConf" :class="'type-group ' + item.menuClass")
              div.type
                label.checked
                  input.checkbox(type="checkbox" @change="onLayersChange(item, name)" v-model="layers" :value="name")
                  span
                  span.marker {{$translate(item.label)}}
                label.new-check
                  input.new-checkbox(type="checkbox")
                  span
              template(v-if="item.groups" v-for="(groupItem, groupItemName) in item.groups")
                div(v-if="groupItem && !groupItem.hideFromMenu").group
                  div(:class="'type ' + groupItem.menuClass")
                    label.checked
                      input.checkbox(type="checkbox" @change="onLayersChange(groupItem, groupItemName, name)" v-model="layers" :value="groupItemName")
                      span
                      span.marker {{$translate(groupItem.label)}}
    router-view
</template>

<script>
  import objectsMixin from './../mixins/objects-mixin'
  import {map as mapEndpoints} from '../../../api/api-endpoints.js'
  import mappingMixin from './../mixins/mapping-mixin'
  import MapMappingLegend from "./../components/map-mapping-legend"
  import MapMappingSelector from "./../components/map-mapping-selector"
  import MapLayerLegend from "./../components/map-layer-legend"

  export default {
    name: 'objects',
    components: {MapMappingSelector, MapMappingLegend, MapLayerLegend},
    mixins: [objectsMixin, mappingMixin],
    methods: {
      getLayersConf () {
        return {
          gs: {
            menuClass: 'oth',
            label: 'Отходообразователи',
            endpoint: mapEndpoints.source,
            className: 'cluster-marker',
            iconType: 'wasteCreators',
            groups: {
              org: {
                menuClass: 'oth-hoz',
                iconType: 'org',
                label: 'Организация/ИП',
                color: 'wasteCreators',
                restApiOrder: 2
              },
              def: {
                menuClass: 'oth-minOb',
                iconType: 'def',
                label: 'Объекты министерства обороны',
                color: 'wasteCreators',
                restApiOrder: 4
              },
              med: {
                menuClass: 'oth-med',
                iconType: 'med',
                label: 'Медицинские учреждения',
                color: 'wasteCreators',
                restApiOrder: 5
              },
              uk: {
                iconType: 'uk',
                menuClass: 'oth-upOrg',
                label: 'Управляющие организации',
                color: 'wasteCreators',
                restApiOrder: 1
              },
              ind: {
                menuClass: 'oth-individ',
                iconType: 'ind',
                label: 'Индивидуальное домовладение',
                color: 'wasteCreators',
                restApiOrder: 6
              },
              country: {
                menuClass: 'oth-garden',
                iconType: 'country',
                label: 'Садовые, дачные партнерства',
                color: 'wasteCreators',
                restApiOrder: 7
              },
              gsk: {
                menuClass: 'oth-garage',
                iconType: 'gsk',
                label: 'ГСК',
                color: 'wasteCreators',
                restApiOrder: 8
              },
              set: {
                menuClass: 'oth-village',
                iconType: 'set',
                label: 'Деревни, поселки, села',
                color: 'wasteCreators',
                restApiOrder: 3
              },
              apartmentBuildings: {
                menuClass: 'oth-apartment-buildings',
                iconType: 'apartmentBuildings',
                label: 'Многоквартирные дома',
                color: 'wasteCreators',
                restApiOrder: 9
              }
            }
          },
          msn: {
            iconType: 'places',
            menuClass: 'places',
            label: 'Места сбора и накопления',
            endpoint: mapEndpoints.msn,
            className: 'cluster-marker msn',
            groups: {
              container: {
                menuClass: 'places-cont',
                iconType: 'container',
                label: 'Контейнерные площадки',
                color: 'places',
                restApiOrder: 1
              },
              noContainer: {
                menuClass: 'places-noCont',
                iconType: 'noContainer',
                label: 'Бесконтейнерный сбор',
                color: 'places',
                restApiOrder: 2
              },
              separate: {
                menuClass: 'places-points',
                iconType: 'separate',
                label: 'Пункты сбора вторсырья',
                color: 'places',
                restApiOrder: 3
              },
              mercurial: {
                menuClass: 'places-lamp',
                iconType: 'mercurial-lamp',
                label: 'Места хранения отработанных ртутьсодержащих ламп',
                color: 'places',
                restApiOrder: 5
              },
              mercurialtemp: {
                menuClass: 'places-term',
                iconType: 'mercurial-term',
                label: 'Места хранения отработанных ртутьсодержащих термометров',
                color: 'places',
                restApiOrder: 6
              },
              specialKgo: {
                menuClass: 'places-points',
                iconType: 'separate',
                label: 'Специальные площадки для КГО',
                color: 'places',
                restApiOrder: 7
              },
              garbageChambers: {
                menuClass: 'places-points',
                iconType: 'separate',
                label: 'Мусороприемные камеры',
                color: 'places',
                restApiOrder: 8
              },
            }
          },
          dump: {
            iconType: 'svalka',
            menuClass: 'svalka',
            label: 'Несанкционированные свалки',
            endpoint: mapEndpoints.heap,
            className: 'cluster-marker heap',
            groups: {
              heap: {
                menuClass: 'svalka-thrash',
                iconType: 'thrash',
                label: 'Навалы мусора',
                color: 'svalka',
                restApiOrder: 1
              },
              unauth: {
                endpoint: mapEndpoints.object,
                menuClass: 'svalka-noThrash',
                iconType: 'noThrash',
                label: 'Несанкционированные ОРО',
                color: 'svalka',
                restApiOrder: 2
              }
            }
          },
          object: {
            iconType: 'garbage',
            menuClass: 'obj',
            label: 'Объекты обращения с отходами',
            endpoint: mapEndpoints.object,
            className: 'cluster-marker object',
            groups: {
              process: {
                menuClass: 'obj-obrab',
                iconType: 'process',
                label: 'Объекты обработки',
                color: 'garbage',
                restApiOrder: 2
              },
              util: {
                menuClass: 'obj-utiliz',
                iconType: 'util',
                label: 'Объекты утилизации',
                color: 'garbage',
                restApiOrder: 5
              },
              neutral: {
                menuClass: 'obj-obezvr',
                iconType: 'neutral',
                label: 'Объекты обезвреживания',
                color: 'garbage',
                restApiOrder: 3
              },
              storage: {
                menuClass: 'obj-chran',
                iconType: 'storage',
                label: 'Объекты хранения',
                color: 'garbage',
                restApiOrder: 4
              },
              burial: {
                menuClass: 'obj-zachoron',
                iconType: 'burial',
                label: 'Объекты захоронения',
                color: 'garbage',
                restApiOrder: 6
              },
              mercury: {
                menuClass: 'obj-mercury',
                iconType: 'burial',
                label: 'Объекты обработки ртутных ламп',
                color: 'garbage',
                restApiOrder: 8
              }
            }
          },
          transport: {
            menuClass: 'transp',
            label: 'Транспортировщики',
            endpoint: mapEndpoints.transport,
            className: 'cluster-marker transport',
            iconType: 'transp',
            groups: {
              transport: {
                hideFromMenu: true,
                iconType: 'transport',
                label: 'Транспортировщики',
                color: 'transp',
                restApiOrder: 1
              }
            }
          }
        }
      },
    }
  }
</script>
